export const FINANCIAL_PICTURE_NODE = "financialPicture";
export const FINANCIAL_PICTURE_DEFAULTS = { title: "Финансовая картина", period: "latest", months: "6", abroad: "1" } as const;

/** A document stores presentation choices only; store access comes from the page scope. */
export function normalizeFinancialPictureAttrs(value: unknown) {
  const raw = value && typeof value === "object" && !Array.isArray(value) ? value as Record<string, unknown> : {};
  const title = typeof raw.title === "string" ? raw.title.replace(/[\u0000-\u001f\u007f]/g, " ").trim().slice(0, 180) : "";
  return {
    title: title || FINANCIAL_PICTURE_DEFAULTS.title,
    period: typeof raw.period === "string" && /^\d{4}-(0[1-9]|1[0-2])$/.test(raw.period) ? raw.period : "latest",
    months: raw.months === "3" || raw.months === "12" ? raw.months : "6",
    abroad: raw.abroad === "0" ? "0" : "1",
  };
}
